import { request } from "./api.js";

export function createReferralInviteActionKey(cryptoSource = globalThis.crypto) {
  if (typeof cryptoSource?.randomUUID === "function") {
    return cryptoSource.randomUUID();
  }
  if (typeof cryptoSource?.getRandomValues === "function") {
    const values = cryptoSource.getRandomValues(new Uint32Array(4));
    return Array.from(values, (value) => value.toString(16).padStart(8, "0")).join("");
  }
  throw new Error("Secure browser randomness is required to create a referral link.");
}

export async function createReferralInviteLink(accountId, options = {}) {
  const normalizedAccountId = String(accountId || "").trim();
  if (!normalizedAccountId) {
    throw new Error("A linked WhatsApp account is required.");
  }
  const idempotencyKey = String(
    options.idempotencyKey || createReferralInviteActionKey(options.cryptoSource),
  ).trim();
  return request("/api/referrals/invite-links", {
    method: "POST",
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ accountId: normalizedAccountId }),
    signal: options.signal,
  });
}
